/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { Divider } from 'antd';
import { useThemeSwitcher } from 'react-css-theme-switcher';

import doReturnTheme from '~src/styles/themeEngine';
import HomeIcon from '~components/_common/HomeIcon/HomeIcon';
import translate from '~src/i18n/translate';
import { EStyleObj } from '~src/types';
import { useProjectId } from '~src/hooks/useProjectId';
import { useIntl } from 'react-intl';

const RightSideViewHomeSu = () => {
  const { currentTheme } = useThemeSwitcher();
  const theme = doReturnTheme(currentTheme);
  const projectId = useProjectId();
  const intl = useIntl();
  const style: EStyleObj = {
    container: {
      display: ' flex',
      flexDirection: 'column',
      height: '100%',
    },
    divider: {
      padding: '0 20px',
    },
    row: {
      display: ' flex',
      flexDirection: 'row',
      marginLeft: '15px',
    },
    column: {
      display: ' flex',
      flexDirection: 'column',
    },
    icons: {
      color: theme.colors.secondary,
      fontSize: '40px',
      margin: '0 6px',
    },
    blue: {
      color: theme.colors.primary,
    },
    red: {
      color: theme.colors.red,
    },
    green: {
      color: theme.colors.green,
    },
    darkGray: {
      color: theme.colors.darkGray,
    },
    yellow: {
      color: theme.colors.yellow,
    },
    small: {
      fontSize: '16px',
    },
  };

  const history = useHistory();

  const clicked = (path) => {
    history.push(path);
  };

  return (
    <div css={style.container}>
      <div css={{ height: '100%' }}>
        {/*  TO BE ADDED BACK WHEN IMPLEMENTED  */}
        <Divider orientation="left" plain css={style.divider}>
          {translate('current-project')}
        </Divider>
        <div css={style.row}>
          <HomeIcon
            name="current-project"
            iconStyle="fad"
            icon="archive"
            customStyle={[style.icons, style.blue]}
            click={() => history.push(`/projects/${projectId}/archive`)}
          />
          <HomeIcon
            name="search"
            iconStyle="far"
            icon="search"
            customStyle={[style.icons, style.black]}
            click={() => history.push(`${projectId}/search`)}
          />
        </div>

        {/* Templates section hidden
        <Divider orientation="left" plain css={style.divider}>
          {intl.formatMessage({ id: 'templates' })}
        </Divider>
        <div css={style.row}>
          <HomeIcon
            name="templates"
            iconStyle="fad"
            icon="folder-tree"
            customStyle={[style.icons, style.yellow]}
            click={() => history.push(`/projects/${projectId}/templates`)}
          />
        </div>
        */}

        <Fragment>
          <Divider orientation="left" plain css={style.divider}>
            {intl.formatMessage({ id: 'project-builder' })}
          </Divider>
          <div css={style.row}>
            <HomeIcon
              name="project-builder"
              iconStyle="fad"
              icon="sliders-h-square"
              customStyle={[style.icons, style.blue]}
              click={() =>
                history.push(`/projects/${projectId}/project-builder`)
              }
            />
          </div>
        </Fragment>

        <Divider orientation="left" plain css={style.divider}>
          {intl.formatMessage({ id: 'deleted-files' })}
        </Divider>
        <div css={style.row}>
          <HomeIcon
            name="deleted-files"
            iconStyle="fad"
            icon="trash"
            customStyle={[style.icons, style.red]}
            click={() => history.push(`${projectId}/deleted-files`)}
          />
        </div>
        {/* Project Data
        <Divider orientation="left" plain css={style.divider}>
          {intl.formatMessage({ id: 'project-data' })}
        </Divider>
        <div css={style.row}>
          <HomeIcon
            name="search"
            iconStyle="far"
            icon="search"
            customStyle={[style.icons, style.black]}
            click={() => history.push(`${projectId}/search`)}
          />
        </div> */}
      </div>
    </div>
  );
};

export default RightSideViewHomeSu;
